/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Yes

==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import { setDefaultScreenFromRoute } from '@/utils/defaultScreen.js'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/', //process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    // {
    //   path: '/',
    //   redirect:'/'
    // },
    // {
    //   path: '/unauthorized',
    //   redirect:'/pages/unauthorized'
    // },
// =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '/',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '',
          name: 'page-portal',
          component: () => import('@/views/pages/Portal.vue')
        },
        {
          path: '/unauthorized',
          name: 'page-unauthorized',
          component: () => import('@/views/pages/Unauthorized.vue')
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        }
      ]
    },
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
              
        {
          path: '/tasks',
          name: 'tasks',
          component: () => import('./views/apps/tasks/Tasks.vue')
        },
        {
          path: '/projectsWorker',
          name: 'projectsWorker',
          component: () => import('./views/apps/projectsWorker/ProjectsWorker.vue')
        },
        {
          path: '/clients',
          name: 'clients',
          component: () => import('./views/clients.vue')
        },
        {
          path: '/workers',
          name: 'workers',
          component: () => import('./views/workers.vue')
        },
        {
          path: '/reports',
          name: 'reports',
          component: () => import('./views/reports.vue')
        },
        {
          path: '/timeentries',
          redirect: { name: 'timeEntries' }
        },
        {
          path: '/timeEntries',
          name: 'timeEntries',
          component: () => import('./views/timeEntries.vue')
        },
        {
          path: '/dailyTime',
          name: 'dailyTime',
          component: () => import('./views/dailyTime.vue')
        },
        {
          path: '/dashboard',
          name: 'dashboard',
          component: () => import('./views/dashboard.vue')
        },
        {
          path: '/sow-maintenance',
          name: 'sow-maintenance',
          component: () => import('./views/sowmaintenance.vue')
        },
        {
          path: '/invoicing',
          name: 'invoicing',
          component: () => import('./views/invoicing.vue')
        },
        {
          path: '/timeBalance',
          name: 'timeBalance',
          component: () => import('./views/timeBalance.vue')
        },
        {
          path: '/timeSummary',
          name: 'timeSummary',
          component: () => import('./views/timeSummary.vue')
        },
        {
          path: '/timeChart',
          name: 'timeChart',
          component: () => import('./views/timeChart.vue')
        },
        {
          path: '/clientHours',
          name: 'clientHours',
          component: () => import('./views/clientHours.vue')
        },
        {
          path: '/settings',
          name: 'settings',
          component: () => import('./views/settings/UserSettings.vue')
        }
      ]
    },

    {
      path: '/client/invoice/:invoiceNumber',
      name: 'client-invoice',
      component: () => import('./views/client/invoice.vue'),
      props: true // Pass the route params as props to the component
    },
    
    
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/'
    }
  ]
})


router.afterEach((to) => {
  setDefaultScreenFromRoute(to.name)
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, from, next) => {
  return next()
})


export default router
